export default {
    created() {
        this.$validator.extend('validate', {
            validate: (value, options) => {
                this.modal.modified = false;
                if (_.isEqual(this.modal.old.name, _.trim(this.modal.item.name)) ||
                    this.loading) {
                    return {
                        valid: false
                    };
                }
                let department = options[0];
                let field = options[1];
                return axios.post(
                    `${this.endpoint}validate`,
                    department
                ).then(response => {
                    this.modal.modified = true;
                    return {
                        valid: true
                    }
                }).catch(error => {
                    let message = _.get(error.response.data, `errors[${field}][0]`);
                    if (message) {
                        return {
                            valid: false,
                            data: {
                                message: message
                            }
                        }
                    } else {
                        this.modal.modified = true;
                        return {
                            valid: true
                        }
                    }
                });
            },
            getMessage: (field, params, data) => {
                return data.message;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/abstract/mixins/validates-items.js